export default __webpack_public_path__ + "static/media/hurricane-ida-relief-2.0c759cc9.png";